/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Phase 14-Final: the theme's native .js__header__stuck class drives BOTH
  // position:fixed pinning AND (via theme.css) the solid header background -
  // but it's added by the theme's own JS at ~scrollY:5px (see stickSimple(),
  // keyed to the header's own offsetTop, which is 0), so the transparent
  // header was turning solid almost immediately on any scroll instead of at
  // the actual hero boundary. theme.css now keys the solid-background/dark-
  // logo rules off a separate .js__header__past-hero class instead (see the
  // "Phase 14-Final" comment there) - this IntersectionObserver is the only
  // thing that sets it, based on the real hero boundary. .js__header__stuck
  // keeps doing its original job (fixed pinning) untouched.
  var heroHeaderObserver = null;
  var heroHeaderResizeTimer = null;

  function headerHeight() {
    var header = document.querySelector('[data-header-height]');
    return header ? header.offsetHeight : 0;
  }

  var headerSentinel = null;

  function initTransparentHeroHeader() {
    if (heroHeaderObserver) {
      heroHeaderObserver.disconnect();
      heroHeaderObserver = null;
    }
    if (headerSentinel && headerSentinel.parentNode) {
      headerSentinel.parentNode.removeChild(headerSentinel);
    }
    headerSentinel = null;

    var headerWrapper = document.querySelector('[data-header-wrapper][data-header-transparent]');
    var hero = document.querySelector('.main-content > .shopify-section.section-overlay-header:first-of-type');
    if (!headerWrapper || !hero) return;

    // The header used to turn solid only once the WHOLE hero had scrolled
    // away, so the transparent nav slid across the hero headline mid-scroll.
    // It now turns solid after a short scroll (about half a header height),
    // through the existing 0.2s fade in theme.css, so nav and hero copy never
    // occupy the same zone. A top-of-page sentinel strip drives it with an
    // IntersectionObserver (no scroll listener): while any part of the strip
    // is on screen the header stays transparent.
    var trigger = Math.max(48, Math.round(headerHeight() / 2));
    headerSentinel = document.createElement('div');
    headerSentinel.setAttribute('aria-hidden', 'true');
    headerSentinel.style.cssText =
      'position:absolute;top:0;left:0;width:1px;height:' + trigger + 'px;pointer-events:none;opacity:0;';
    document.body.appendChild(headerSentinel);

    heroHeaderObserver = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        headerWrapper.classList.toggle('js__header__past-hero', !entry.isIntersecting);
      },
      { root: null, threshold: 0 }
    );
    heroHeaderObserver.observe(headerSentinel);
  }

  function scheduleReinit() {
    clearTimeout(heroHeaderResizeTimer);
    heroHeaderResizeTimer = setTimeout(initTransparentHeroHeader, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTransparentHeroHeader);
  } else {
    initTransparentHeroHeader();
  }

  window.addEventListener('resize', scheduleReinit);

  // Re-attach if the header or hero section is replaced by a Theme Editor
  // section reload, per this repo's "must survive section reloads" rule.
  // initTransparentHeroHeader() disconnects any previous observer first,
  // so this never accumulates duplicate observers across reloads.
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('[data-header-wrapper]') || event.target.querySelector('.section-overlay-header')) {
      initTransparentHeroHeader();
    }
  });

  // Cart drawer "Alışverişe Devam Et": delegated so it survives section reloads. It only forwards the click to the
  // drawer's own close control (first [data-cart-drawer-close]), so closing, focus return and Escape stay the theme's.
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-cart-continue]');
    if (!button) return;
    var drawer = button.closest('cart-drawer');
    var close = drawer && drawer.querySelector('[data-cart-drawer-close]');
    if (close) {
      event.preventDefault();
      // Closing hands focus back to the control that opened the drawer (e.g. Add to Cart), and the browser scrolls a
      // focused control into view. Keep the customer exactly where they were browsing.
      var x = window.scrollX;
      var y = window.scrollY;
      close.click();
      var restore = function () {
        if (Math.abs(window.scrollY - y) > 1 || Math.abs(window.scrollX - x) > 1) window.scrollTo(x, y);
      };
      window.requestAnimationFrame(restore);
      window.setTimeout(restore, 120);
      window.setTimeout(restore, 400);
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
